import React, { Component } from 'react';
import AdministratorsDetails from './AdministratorsDetails';
import commonUtil from './../../../../../../utils/commonUtil';
import ConfirmDeleteOwnerPopUp from './ConfirmDeleteOwnerPopUp';

export default class Body extends Component {
  state = {
    ownerForDelete: '',
  }
  addNewCoOwner = () => {
    this.props.addNewCoOwner();
  }
  confirmationAcceptedCB = () => {
    this.adminDetail.deleteCoOwner(this.deleteCelebrity, this.eventId, this.activeEventsInfo, this.loggedInUserType);
    this.confirmationRejectedCB();
  }
  confirmationRejectedCB = () => {
    this.modal.handleHide();
    this.eventId = '';
    this.deleteCelebrity = '';
    this.setState({
      ownerForDelete: '',
    });
  }
  deleteModal = (celebrityInfo, eventId, activeEventsInfo, loggedInUserType) => {
    this.deleteCelebrity = celebrityInfo;
    this.eventId = eventId;
    this.activeEventsInfo = activeEventsInfo;
    this.loggedInUserType = loggedInUserType;
    this.setState({
      ownerForDelete: celebrityInfo,
    });
    this.modal.handleShow();
  }
  render() {
    const { userEventDetails, lables } = this.props;
    const eventStatusForSuspended = this.props.eventStatusForSuspended;
    const celebrityInfo = userEventDetails.eventDetailsInfo.celebrityInfo;
    return (
      <div className="row myEventAdminInfo myevent_border">
        <ConfirmDeleteOwnerPopUp
          lables={this.props.lables}
          ref={modal => this.modal = modal}
          confirmationAcceptedCB={this.confirmationAcceptedCB}
          confirmationRejectedCB={this.confirmationRejectedCB}
          celebrity={this.state.ownerForDelete}
        />
        <div className="col-sm-9">
          <h2>{commonUtil.getLabel(lables.eventDetails, 'eventManagement.eventDetails.celebratedAndAdministrators')} </h2>
          {userEventDetails.eventDetailsInfo.canAddOwner === 'true' && eventStatusForSuspended === false ?
            <a className="addAdministrator principalLink agregar_administrator" onClick={this.addNewCoOwner} href="javascript:void(0)">
              <i className="icon-mas icon_font" />Agregar administrador</a>
            :
            null
          }
          {celebrityInfo.map((celeb, id) => (
            <AdministratorsDetails ref={adminDetail => this.adminDetail = adminDetail} deleteModal={this.deleteModal} celebrityInfo={celeb} key={id} {...this.props} eventStatusForSuspended={eventStatusForSuspended} selectedEventConfiguration={this.props.selectedEventConfiguration} userEventDetails={userEventDetails} />
          ))}
        </div>
        {/* <div className="col-sm-3 addAdminButton"> */}
        {/* removed condition from below */}
        {/* && this.getIsAddingCoOwnerAllowed(userEventDetails.eventDetailsInfo) */}
        {/* </div> */}
      </div>
    );
  }
}
